<template>
  <div class='SelectFontStyle'>
    <div class="label">{{ text }}</div>
    <div class="check">
      <input :checked="value" type="checkbox" @change="e => $emit('update', !value)">
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectFontStyle',
  props: {
    text: {
      type: String,
      default: 'Label'
    },
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.SelectFontStyle {
  display: flex;
  align-items: center;
  padding-top: 1%;
  padding-bottom: 1%;
  border-bottom: thin solid #CCCCCC;
}

.label {
  width: 50%;
  text-align: start;
}

.check {
  display: flex;
  justify-content: end;
  width: 50%;
}
</style>
